import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { PaginationParams } from 'models';

export const getCounteroffersMore = createAsyncThunk(
	'secondaryMarket/getCounteroffersMore',
	async (params?: PaginationParams) => {
		return await SecondaryMarketService.getCounteroffers(params);
	},
);
